<!--
  - Copyright (c) 2019 Eva Novotná, Juraj Šimon
  -->

<template>
  <div class="slider-wrapper">
    <swiper ref="mySwiper" class="top-swiper" :options="swiperOptions">
      <slide
        background-image-class="ski-slide"
        bottom-label="Coach"
        top-label="Skiing"
      ></slide>
      <slide
        background-image-class="swim-slide"
        bottom-label="Coach"
        top-label="Swimming"
      ></slide>
      <slide
        background-image-class="run-slide"
        bottom-label="Coach"
        top-label="Running"
      ></slide>
      <div class="swiper-pagination" slot="pagination"></div>
      <div class="swipe-prev" slot="button-prev">
        <left-arrow class="arrow" @click="swipePrev" />
      </div>
      <div class="swipe-next" slot="button-next">
        <right-arrow class="arrow" @click="swipeNext" />
      </div>
    </swiper>
    <slot name="bottom-bar"></slot>
  </div>
</template>

<script>
import LeftArrow from "./../assets/keyboard_arrow_left-24px.svg";
import RightArrow from "./../assets/keyboard_arrow_right-24px.svg";
import Slide from "./top-slider/slide";

export default {
  props: {},
  components: {
    LeftArrow,
    RightArrow,
    Slide
  },
  methods: {
    swipeNext() {
      this.swiper.slideNext(500);
    },
    swipePrev() {
      this.swiper.slidePrev(500);
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
    swiperOptions() {
      return {
        slidesPerView: 1,
        autoplay: {
          delay: 3000
        },
        // autoHeight: true,
        spaceBetween: 0,
        allowTouchMove: true,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      };
    }
  }
};
</script>

<style lang="scss">
@import "sports";
@import "top-slider-unscoped";
</style>
